import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Ionic from '@ionic/vue'
import '@ionic/core/css/ionic.bundle.css'
import i18n from './i18n'
import Snotify, { SnotifyPosition } from 'vue-snotify'
import VueAxios from 'vue-axios'
import VueSocialauth from 'vue-social-auth'
import axios from 'axios'
import VueWindowSize from 'vue-window-size'
import Ads from 'vue-google-adsense'
import VueGtag from 'vue-gtag'
import Fragment from 'vue-fragment'
import { constants, firebaseConfig } from './constants'
import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'

Vue.use(Fragment.Plugin)
Vue.use(require('vue-script2'))
Vue.use(Ads.Adsense)
Vue.use(VueGtag, {
    config: { id: 'UA-21613811-1' }
})
Vue.use(VueAxios, axios)
Vue.use(VueSocialauth, {
    providers: {
        facebook: {
            clientId: '393724608164741',
            redirectUri: `${constants.clientUri}`
        },
        google: {
            clientId: '756601747177-r3clvuf15pvlcsda61qp4dmbajqf306m.apps.googleusercontent.com',
            redirectUri: `${constants.clientUri}`
        }
    }
})

const snotifyOptions = {
    toast: {
        position: SnotifyPosition.centerBottom,
        titleMaxLength: 40,
        icon: false
    }
}

Vue.use(Snotify, snotifyOptions)

Vue.use(Ionic)

Vue.use(VueWindowSize, {
    delay: 0
})

Vue.config.productionTip = true

//FIREBASE CONFIG
const app = initializeApp(firebaseConfig)
const analytics = getAnalytics(app)
Vue.prototype.$analytics = analytics

const init = () => {
    new Vue({
        router,
        store,
        i18n,
        render: h => h(App)
    }).$mount('#app')
}

function onAdLoaded(e) {
    if (e.adType === admob.AD_TYPE.AD_TYPE_BANNER) {
        console.log('New banner received')
    } else if (e.adType === admob.AD_TYPE.INTERSTITIAL) {
        console.log(
            "An interstitial has been loaded and autoshown. If you want to automatically show the interstitial ad, set 'autoShowInterstitial: true' in admob.setOptions() or remove it"
        )
        admob.showInterstitialAd()
    } else if (e.adType === admob.AD_TYPE_REWARDED) {
        console.log('New rewarded ad received')
        admob.showRewardedAd()
    }
    setTimeout(admob.createBannerView, 1000 * 120)
    setTimeout(admob.requestInterstitialAd, 1000 * 120)
}

// Wait for the deviceready event to start the render
document.addEventListener('deviceready', () => {
    //handle android back button
    document.addEventListener(
        'backbutton',
        function (e) {
            e.preventDefault()
            router.back()
        },
        false
    )

    init()

    if (window.plugins) {
        navigator.splashscreen.hide()

        admob.banner.config({
            id: 'ca-app-pub-9822209171586486/8874226625'
        })
        // Create banner
        admob.banner.prepare()
        // Show the banner
        admob.banner.show()

        //Remove this method to stop OneSignal Debugging
        window.plugins.OneSignal.setLogLevel({ logLevel: 6, visualLevel: 0 })

        var notificationOpenedCallback = function (jsonData) {
            console.log('notificationOpenedCallback: ' + JSON.stringify(jsonData))
        }
        // Set your iOS Settings
        var iosSettings = {}
        iosSettings['kOSSettingsKeyAutoPrompt'] = false
        iosSettings['kOSSettingsKeyInAppLaunchURL'] = false

        window.plugins.OneSignal.startInit('b1c4f61b-2d3a-4c3d-b42d-3038ba0cd057')
            .handleNotificationOpened(notificationOpenedCallback)
            .iOSSettings(iosSettings)
            .inFocusDisplaying(window.plugins.OneSignal.OSInFocusDisplayOption.Notification)
            .endInit()

        // The promptForPushNotificationsWithUserResponse function will show the iOS push notification prompt. We recommend removing the following code and instead using an In-App Message to prompt for notification permission (See step 6)
        window.plugins.OneSignal.promptForPushNotificationsWithUserResponse(function (accepted) {
            console.log('User accepted notifications: ' + accepted)
        })
    }
})

// If we are not in Cordova, manually trigger the deviceready event
const isCordovaApp = typeof window.cordova !== 'undefined'
if (!isCordovaApp) {
    document.dispatchEvent(new CustomEvent('deviceready', {}))
}
